module.exports = __webpack_public_path__ + "img/overview-vacancy-item.dd6e309b.png";